module.exports = __webpack_public_path__ + "media/images/countryrect/ie-325327372ac2e2c6f96130fef213a0a9.svg";